export class SortingColumn {
	public name: string;
	public displayName: string;
	public isSelected: boolean;
	public dataType: string;

	public constructor(props: Required<SortingColumn>) {
		this.name = props.name;
		this.displayName = props.displayName;
		this.isSelected = props.isSelected;
		this.dataType = props.dataType;
	}
}
